/* TK – Fakturačné údaje na firmu (voliteľné).
   - checkbox rozbalí/zbalí polia
   - hodnoty sa priebežne ukladajú ako cart attributes cez /cart/update.js
     (aby prežili Dawn AJAX re-render aj notification/drawer flow)
   - polia sú zároveň napojené cez form="..." na checkout formulár (natívny submit)
   - funguje na cart page aj v cart drawer; viac inštancií drží v sync */
(function () {
  var KEYS = {
    toggle: 'Fakturovať na firmu',
    name: 'Názov spoločnosti',
    ico: 'IČO',
    dic: 'DIČ',
    icdph: 'IČ DPH',
  };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var saveTimer = null;

  function fieldsOf(wrap) {
    return {
      cb: wrap.querySelector('.tk-invoice__checkbox'),
      panel: wrap.querySelector('.tk-invoice__panel'),
      name: wrap.querySelector('input[name="attributes[Názov spoločnosti]"]'),
      ico: wrap.querySelector('input[name="attributes[IČO]"]'),
      dic: wrap.querySelector('input[name="attributes[DIČ]"]'),
      icdph: wrap.querySelector('input[name="attributes[IČ DPH]"]'),
    };
  }

  function textInputs(f) {
    return [f.name, f.ico, f.dic, f.icdph].filter(Boolean);
  }

  // Zapíš stav jednej inštancie do všetkých ostatných (drawer <-> cart page)
  function mirror(source) {
    var s = fieldsOf(source);
    document.querySelectorAll('[data-tk-invoice]').forEach(function (wrap) {
      if (wrap === source) return;
      var f = fieldsOf(wrap);
      if (f.cb && s.cb) f.cb.checked = s.cb.checked;
      applyOpenState(wrap, s.cb ? s.cb.checked : false);
      [['name', 'name'], ['ico', 'ico'], ['dic', 'dic'], ['icdph', 'icdph']].forEach(function (p) {
        if (f[p[0]] && s[p[1]]) f[p[0]].value = s[p[1]].value;
      });
    });
  }

  function applyOpenState(wrap, open) {
    var f = fieldsOf(wrap);
    if (f.panel) f.panel.hidden = !open;
    if (f.cb) f.cb.setAttribute('aria-expanded', open ? 'true' : 'false');
    textInputs(f).forEach(function (input) {
      input.disabled = !open;
    });
  }

  function collect(wrap) {
    var f = fieldsOf(wrap);
    var open = !!(f.cb && f.cb.checked);
    return {
      open: open,
      attrs: {
        'Fakturovať na firmu': open ? 'Áno' : '',
        'Názov spoločnosti': open && f.name ? f.name.value.trim() : '',
        'IČO': open && f.ico ? f.ico.value.trim() : '',
        'DIČ': open && f.dic ? f.dic.value.trim() : '',
        'IČ DPH': open && f.icdph ? f.icdph.value.trim() : '',
      },
    };
  }

  function persist(wrap) {
    var data = collect(wrap);
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: data.attrs }),
    }).catch(function () {});
  }

  function debouncedPersist(wrap) {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      persist(wrap);
    }, 500);
  }

  function bind(wrap) {
    if (!wrap || wrap.dataset.tkBound) return;
    wrap.dataset.tkBound = '1';
    var f = fieldsOf(wrap);
    if (!f.cb) return;

    applyOpenState(wrap, f.cb.checked);

    f.cb.addEventListener('change', function () {
      applyOpenState(wrap, f.cb.checked);
      if (f.cb.checked) {
        var first = textInputs(f)[0];
        if (first) first.focus();
      }
      mirror(wrap);
      persist(wrap);
    });

    textInputs(f).forEach(function (input) {
      input.addEventListener('input', function () {
        mirror(wrap);
        debouncedPersist(wrap);
      });
      input.addEventListener('change', function () {
        mirror(wrap);
        persist(wrap);
      });
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-tk-invoice]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  // Dawn po zmene košíka prekresľuje sekcie -> naviazať znova
  document.addEventListener('cart:refresh', bindAll);
  document.addEventListener('cart:updated', bindAll);
  document.addEventListener('shopify:section:load', bindAll);
})();
